<section id="why-wise" class="d-flex align-items-center bg-white fullwidth-section">
  <div class="app-container container-xl container-xl-max-md w-100 py-12">
    <div class="col-12">
      <div class="row">
        <div #left_content class="col-12">
          <div class="mb-12 text-center" #header>
            <span class="fw-bold fs-2hx">
              {{ "LANDING_PAGE.WHY_WISE" | translate }}
            </span>
          </div>

          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-6">
            @for (obj of objectiveList; track $index) {
            <div class="col d-flex">
              <!-- White cards with a tinted icon well, rather than four solid
                   blocks of brand colour: at four-across, solid fills read as a
                   wall and bury the text that is doing the actual work. -->
              <div class="card flex-1 hover-elevate-up">
                <div class="card-body d-flex flex-column align-items-center text-center">
                  <div class="d-flex align-items-center justify-content-center rounded-circle bg-light-primary mb-6"
                    style="width: 104px; height: 104px">
                    <img [src]="obj.image_url" [alt]="obj.alt" class="w-70px h-70px" />
                  </div>
                  <div class="fs-3 fw-bold text-gray-900 mb-3">{{ obj.name }}</div>
                  <div class="fs-6 fw-normal text-gray-600 lh-lg">{{ obj.description }}</div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        <!-- <div #right_content class="col-12 col-md-6 d-flex flex-column flex-end">
          <div class="fw-bold fs-4">
            <img
              src="./assets/media/landing/about-teaching.webp"
              class="w-100 mw-500px rounded"
            />
            <p class="mt-4">
              — Dr. Wise Knowbest
              <span class="text-muted">({{ "APP.TEACHER" | translate }})</span>
            </p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="row"> -->
  <!-- </div> -->
</section>